import actions from "./actions";

const initState = {
  websites: null,
  bonusWebsites: null,
  roles: null,
  schools: null,
  grades: null,
  users: null,
  key: null,
  singleBonusWebSite: null,
};

export default function userReducer(state = initState, action) {
  switch (action.type) {
    case actions.FETCH_WEBSITES_SUCCESS:
      return { ...state, websites: action.websites };
    case actions.FETCH_BONUS_WEBSITES_SUCCESS:
      return { ...state, bonusWebsites: action.bonusWebsites };
    case actions.FETCH_BONUS_USERS_SUCCESS:
      return { ...state, users: action.users };
    case actions.FETCH_BONUS_CONFIGS_SUCCESS:
      return {
        ...state,
        roles: action.roles,
        schools: action.schools,
        organizations: action.organizations,
        grades: action.grades,
      };
    case actions.SET_FILTER:
      return { ...state, key: action.key };
    case actions.RESET:
      return { ...state, websites: null };
    case actions.FETCH_SCHOOL_SUCCESS:
      return { ...state, schools: action.schools };
    case actions.GET_USER_RECORD_WEB_SUCCESS:
      return { ...state, singleBonusWebSite: action.bonusBook };
    default:
      return state;
  }
}
